import material from "../../assets/solutions/Alternative_Materials.png";
import assistive_technology from "../../assets/solutions/Assistive_technologies.png";
import clean from "../../assets/solutions/Clean_energy.png";
import Decarbonisation from "../../assets/solutions/Decarbonization.png";
import environment from "../../assets/solutions/Envoronment_and_circular_solutions.png";
import organic from "../../assets/solutions/Organic_dye.png";

export const solutionData = [
  {
    id: 1,
    img: material,
    title: "Alternative Materials",
    question:
      "How can we introduce alternative materials into the RMG production to reduce cotton dependency, lower environmental impact and create alternative job options for women garment workers?",
    description: `Develop sustainable and new eco-friendly materials that serve as viable alternatives to traditional fabric or develop more efficient manufacturing methods that can be used to scale the usage of these new materials in the industry taking into account specificities of garment production processes. `,
    example: "Example of startups bringing eco-friendly material innovation:  ",
    links: {
      "BOLT THREADS": "https://boltthreads.com/",
      "ANANAS ANAM": "https://www.ananas-anam.com/",
      "GREEN NETTLE TEXTILE": "https://greennettletextiles.com/",
      ALGAEING: "https://www.algaeing.com/",
      "ALT TEX": "https://thealttex.com/",
      "ORANGE FIBER": "http://www.orangefiber.it/",
      "RETHREAD AFRICA": "https://rethread.africa/",
    },
  },
  {
    id: 2,
    img: environment,
    title: "Environment and Circular Solution",
    question:
      "What innovative circular solutions can be proposed to effectively reduce the carbon footprint linked to energy usage, waste management, packaging, and water treatment of the RMG industry?",
    description: ` This initiative is centered around the exploration of sustainable and circular solutions that minimize the carbon footprint linked to energy usage, waste management, packaging, and water treatment. The primary focus is on finding solutions in several areas such as improved energy efficiency, improved water recovery, reduced discharge of chemical effluents, reduced generation of fabric waste, alternatives to single use plastics, just to name a few.`,
    example:
      "Example of startups building innovative environment and circular solutions:  ",
    links: {
      "CIRCULAR SYSTEMS": "http://www.circularsystems.com",
      EVRNU: "http://www.evrnu.com",
      BIORESTORE: "https://www.biorestore.eu/",
      DYERECYCLE: "https://www.dyerecycle.com/",
      IONCELL: "http://www.ioncell.fi/",
      TEREFORM: "https://www.tereform.com/",
      EON: "https://www.eongroup.co/",
    },
  },
  {
    id: 5,
    img: clean,
    title: "Clean Energy",
    question:
      "How can we accelerate the adoption of clean energy in the Bangladesh RMG industry through scalable innovations and socially beneficial models which reduce reliance on fossil fuels and promote sustainable power generation?",
    description: `This area of focus emphasizes integrating solar, wind, and other renewable energy sources into garment factories, reducing dependency on non-renewable fuels, and improving overall energy resilience. It also involves creating financing and business models that make renewable energy affordable and scalable for manufacturers. Women RMG workers can contribute by participating in energy awareness programs, operating solar-powered machinery, managing factory-level green energy initiatives, and even engaging in community-level microgrid systems to ensure broader energy access.`,
    example: "Examples of startups working with clean energy models:",
    links: {
      SunFunder:
        "https://unfccc.int/climate-action/un-global-climate-action-awards/financing-for-climate-friendly-investment/sunfunder",
      Bboxx: "https://www.bboxx.com/",
      "d.light": "https://www.dlight.com/",
      SolarEdge: "https://www.solaredge.com/us",
    },
  },
  {
    id: 3,
    img: Decarbonisation,
    title: "Decarbonization",
    question:
      "How can we decarbonize the Bangladesh RMG industry through scalable innovations and socially beneficial models which reduce carbon emissions, promote energy efficiency, and accelerate the transition to renewable energy?",
    description: `This area of focus centers around the adoption of low-carbon production processes, renewable energy integration, and green manufacturing practices in the RMG supply chain. It also involves designing business models that incentivize carbon reduction, enhance energy efficiency, and improve overall sustainability standards across factories. Women RMG workers can contribute by adopting energy-efficient practices in production lines, supporting green factory operations, learning new skills in sustainable manufacturing, and even participating in climate-focused community initiatives.
`,
    example: "Examples of startups working with decarbonization models:",
    links: {
      CarbonCure: "https://www.carboncure.com/",
      Climeworks: "https://climeworks.com/",
      "Envision Digital": "https://www.envision-group.com/",
      "NextEra Energy Resources": "https://www.nexteraenergyresources.com/",
    },
  },
  {
    id: 4,
    img: assistive_technology,
    title: "Assistive Technology",
    question:
      "How can better process and assistive technologies focus on helping the women RMG workers to overcome barriers, improve productivity, and enhance their overall well-being in the workplace?",
    description: `'Better Process’ focuses on optimizing workflows, increasing efficiency, and minimizing waste. This can be achieved by incorporating advanced technologies, modular/digital solutions for transparency & traceability across the value chain automation or adopting lean manufacturing principles. ‘Assistive technology’ refers to devices, tools, or systems designed to assist individuals with disabilities or limitations in performing various tasks or accelerating workers’ efficiency. This context may include specialized sewing machines or tools accommodating different physical abilities, ergonomic workstations, assistive software, wearable devices or robotic arms that aid in communication, mobility or speedy execution of tasks. `,
    example: "Example of startups bringing better process & technologies: ",
    links: {
      "SEWBO ": "http://www.sewbo.com",
      SXD: "https://www.sxd-ai.com/",
      SYNFLUX: "https://synflux.io/",
      "REVERSE RESOURCES": "http://www.reverseresources.net/",
      "TEXTILE GENESIS": "https://textilegenesis.com/",
      UNSPUN: "https://unspun.io/",
      BIGTHINX: "http://www.bigthinx.com",
    },
  },
  {
    id: 6,
    img: organic,
    title: "Organic Dye",
    question: `How can we introduce sustainable eco-friendly practices in dyeing and finishing of garments to reduce the use of hazardous chemicals and minimize environmental discharge?`,
    description: `This focus area emphasizes transitioning from conventional, chemical-intensive dyeing and finishing methods to cleaner, safer, and more resource-efficient alternatives. It highlights innovations in natural dye extraction, waterless dyeing technologies, enzyme-based finishing, and closed-loop wastewater treatment systems. By reducing dependence on toxic dyes and excessive water use, these solutions help lower carbon footprints, protect ecosystems, and improve worker health and safety.

Integrating sustainable dyeing practices also contributes to circularity, allowing wastewater to be reused, chemicals to be recovered, and energy consumption to be reduced through advanced process optimization. Women RMG workers can play a key role

by learning green dyeing methods, monitoring chemical safety, and ensuring compliance with environmental standards.
`,
    example: "Examples of startups and companies pioneering sustainable dyeing innovations: ",
    links: {
      Colorifix: "https://www.colorifix.com/",
      Dyecoo: "https://dyecoo.com/co2-dyeing/",
      Jeanologia: "https://www.jeanologia.com/garment/colorbox/",
    },
  },

  // {
  //   id: 6,
  //   img: solution6,
  //   title: "Better process and Assistive technologies",
  //   question: "How can better process and assistive technologies focus on helping the women RMG workers to overcome barriers, improve productivity, and enhance their overall well-being in the workplace?",
  //   description: `'Better Process’ focuses on optimizing workflows, increasing efficiency, and minimizing waste. This can be achieved by incorporating advanced technologies, modular/digital solutions for transparency & traceability across the value chain automation or adopting lean manufacturing principles. ‘Assistive technology’ refers to devices, tools, or systems designed to assist individuals with disabilities or limitations in performing various tasks or accelerating workers’ efficiency. This context may include specialized sewing machines or tools accommodating different physical abilities, ergonomic workstations, assistive software, wearable devices or robotic arms that aid in communication, mobility or speedy execution of tasks. `,
  //   example: "Example of startups bringing better process & technologies: ",
  //   links: {
  //     "SEWBO ": "http://www.sewbo.com",
  //     "SXD": "https://www.sxd-ai.com/",
  //     "SYNFLUX": "https://synflux.io/",
  //     "REVERSE RESOURCES": "http://www.reverseresources.net/",
  //     "TEXTILE GENESIS": "https://textilegenesis.com/",
  //     "UNSPUN": "https://unspun.io/",
  //     "BIGTHINX": "http://www.bigthinx.com"
  //   }
  // },
];
